<template>
	<div>

		<div v-scroll="onScroll">
			
			<div full-width class="search-filter two-btn">
		    	<v-text-field full-width hide-details elevation-10 flat solo placeholder="Search..." v-model.lazy="searchValue" @input="fn_searchItem" class="search-box" :class="{'bottom-shadow':scrollPositionTop!=0}"></v-text-field>
		    	
				<div v-ripple style="float:left" class="filter-btn" @click="fn_openFilterDialog">
		    		<v-icon>filter_list</v-icon>
		    		<span style="font-size: 48px;position: absolute;bottom: -6px;right: 6px;color: #4b77be;" v-if="selectedTransactionListIds.length">&bull;</span>
		    	</div>

				<div v-ripple class="filter-btn">
		    		<v-menu>
						<v-icon slot="activator">more_vert</v-icon>

						<v-list nopadding>
							<v-list-tile @click="fn_markClear(true)">
								<v-list-tile-title>Close Bills/Invoices</v-list-tile-title>
							</v-list-tile>
							<v-list-tile @click="fn_markClear(false)">
								<v-list-tile-title>Reopen Bills/Invoices</v-list-tile-title>
							</v-list-tile>
						</v-list>

					</v-menu>
		    	</div>
		    </div>
			
			<div style="clear:both">

				<div class="pa-4 light-opacity-color font12" v-if="$root.appVersion<202">Install updated app to get all pending invoices</div>
				
				<v-list grey-back three-line nopadding v-if="listItemObject.items && listItemObject.items.length">

					<v-subheader style="position: sticky;top: 0px;z-index: 1;" white-background subheader-dense>
						Count: {{$root.numberToLocale(listItemObject.totalCount, 1)}}
						<v-spacer></v-spacer>

						<v-menu>
							<!-- <v-icon slot="activator">more_vert</v-icon> -->

							<div slot="activator" class="font11" style="padding-left: 8px;display: flex;align-items: center;border: 1px #ddd solid;border-radius: 5px;" v-ripple>
								<div style="max-width: 140px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
									<template v-if="selectedDate">
										Due at <span v-if="selectedDueDays != null">: {{ selectedDate | moment("DD-MMM-YYYY")}}</span>
									</template>
									<template v-else>
										Due <span v-if="selectedDueDays != null">: {{ selectedDueDays ? selectedDueDays + ' days' : 'Today' }}</span>
									</template>
								</div>
								<v-icon>arrow_drop_down</v-icon>
							</div>

							<v-list densed nopadding>
								<v-list-tile @click="fn_searchItem(0)">
									<v-list-tile-title>Today</v-list-tile-title>
								</v-list-tile>
								<v-list-tile @click="fn_searchItem(7)">
									<v-list-tile-title>7 Days</v-list-tile-title>
								</v-list-tile>
								<v-list-tile @click="fn_searchItem(10)">
									<v-list-tile-title>10 Days</v-list-tile-title>
								</v-list-tile>
								<v-list-tile @click="fn_searchItem(15)">
									<v-list-tile-title>15 Days</v-list-tile-title>
								</v-list-tile>
								<v-list-tile @click="fn_searchItem(30)">
									<v-list-tile-title>30 Days</v-list-tile-title>
								</v-list-tile>
								<v-list-tile @click="fn_searchItem(45)">
									<v-list-tile-title>45 Days</v-list-tile-title>
								</v-list-tile>
								<v-list-tile @click="fn_searchItem(90)">
									<v-list-tile-title>90 Days</v-list-tile-title>
								</v-list-tile>
								<!-- <v-list-tile @click="fn_openDatePicker">
									<v-list-tile-title>Select Date</v-list-tile-title>
								</v-list-tile> -->
							</v-list>

						</v-menu>
						
					</v-subheader>


					<div white-background v-for="(item, index) in listItemObject.items" :key="index" :class="{'margin-top-ten':index!=0}" :id="'item_'+item.transactionId">
						<v-list-tile class="right-subtitle-tile" @click="fn_itemClick(item, index)">
						    <v-list-tile-content>
						      <v-list-tile-title>{{item.partyName ? item.partyName : fn_transactionName(item)}}</v-list-tile-title>
						      <!-- <v-list-tile-sub-title v-if="item.partyName">{{fn_transactionName(item)}}</v-list-tile-sub-title> -->
						      <v-list-tile-sub-title>
						      	<span v-if="item.baseTransactionNumber" class="primary-color">{{item.baseTransactionNumber}}</span>
						      	{{item.baseTransactionNumber ? ' | ' : ''}}
						      	{{item.transactionDate | moment("DD-MMM-YYYY")}}
						      </v-list-tile-sub-title>
							  <v-list-tile-sub-title>Bill Amount: &#8377; {{ $root.numberToLocale(item.roundedAmount) }}</v-list-tile-sub-title>
						      <!-- <v-list-tile-sub-title>{{item.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title> -->
						    </v-list-tile-content>

						    <v-list-tile-action align-flex-end style="justify-content: end;">
						    	<!-- <div class="warning-label" v-if="!item.status">Cancelled</div> -->
						    	<!-- empty div to align amount at bottom of the tile -->
						    	<!-- <div v-else></div> -->
								<div class="font14" :class="[item.dueDays > 0 ? 'redcolor' : 'greencolor']">
									<span v-if="item.dueDays == 0">Due today</span>
									<span v-if="item.dueDays > 0">Due {{item.dueDays}} days</span>
									<span v-else-if="item.dueDays < 0">Due in {{item.dueDays}} days</span>
								</div>
								<div light-opacity-color font12>{{ item.transactionListId == 10004 || item.transactionListId == 20003 || item.transactionListId == 20005 ? 'To Pay' : 'To Receive' }}</div>
						    	<div>&#8377; {{$root.numberToLocale(item.outStandingAmount)}}</div>
						    </v-list-tile-action>

						</v-list-tile>

						<v-divider v-if="item.invoiceTemplate"></v-divider>
						<div right-align style="padding:2px 6px" v-if="item.invoiceTemplate">
							<v-btn nomargin icon flat @click="bindInvoiceTemplate('sharewhatsapp', item)"><img src="../../../assets/icon_whatsapp.svg" style="width:20px" alt="whatapp_icon"></img></v-btn>
							<v-btn nomargin icon flat @click="bindInvoiceTemplate('share', item)"><v-icon font20>share</v-icon></v-btn>
					    	<v-btn nomargin icon flat @click="bindInvoiceTemplate('print', item)"><v-icon font20>print</v-icon></v-btn>
					    	<v-btn nomargin icon flat @click="preview(item, fn_transactionName)">
					    		<img src="../../../assets/icon_preview_black.svg" style="width:20px" alt="whatapp_icon"></img>
					    	</v-btn>
							<v-btn nomargin icon flat @click="fn_InvoicePaymentReminder(item)" v-if="item.transactionListId == 10003">
					    		<v-icon font20>notifications_none</v-icon>
					    	</v-btn>
					    </div>

					</div>


				</v-list>

				<!-- <transition name="fade" mode="out-in">

					<v-card noshadow class="create-placeholder-card" v-if="showPlaceHolder && !listItemObject.totalCount">
						<v-card-text @click="add">

							<div center-align>
				            	<div v-ripple class="placeholder-icon">
				            		<i aria-hidden="true" class="v-icon material-icons add-icon">add</i>
				            		<img src="../../../assets/icon_wallet.svg" alt="">
				            	</div><br>

				            	<p class="title light-opacity-color">Create New Transaction</p>
				            </div>
						</v-card-text>
					</v-card>
				</transition> -->

			</div>

		</div>

		<dialog-mark-clear ref="ref_dialogMarkClear" :showBottomNavigation="showBottomNavigation" :refreshList="fn_searchItem" :clearValue="clearValue"></dialog-mark-clear>

		<dialog-transaction-list ref="ref_dialogTransactionList" :transactionForms="transactionForms" :selectedTransactionListIds="selectedTransactionListIds" :selectItems="fn_selectItems" :clearAll="fn_clearAll"></dialog-transaction-list>
		
		<dialog-due-days ref="ref_dialogDueDays"></dialog-due-days>

		<dialog-date-picker ref="ref_dialogDatePicker" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-date-picker>
	</div>
</template>

<script>
const transactionForms = require('../../../config.js').configs.transactionForms;
const transactionTypes = require('../../../config.js').configs.transactionTypes;
import dialogPendingInvoices from '../../transactions/forms/dialogs/dialog_mark_invoice_clear'

import dialogTransactions from '../dialogs/dialog_transaction_list'

import dialogDueDays from '../../dialogs/dialog_due_days_filter'

import dialogDatePicker from '../../dialogs/dialog_datepicker'

	export default{
		props:['preview', 'bindInvoiceTemplate', 'showBottomNavigation', 'hideBottomNavigation'],
		components: {
		    // InfiniteLoading,
		    'dialog-transaction-list':dialogTransactions,
			'dialog-mark-clear':dialogPendingInvoices,
			'dialog-due-days':dialogDueDays,
			'dialog-date-picker':dialogDatePicker
		},
		data(){
			return{
				toolbarTitle:null,
				listItemObject:{"items":[], "totalCount":0, "saleTotal":0, "receiptTotal":0},
				searchValue:'',
				infiniteId: +new Date(),
				startIndex:0,
				scrollPositionTop:0,
				selectedItemId:null,
				// transactionListId:null,
				transactionForms:null,
				selectedTransactionListIds:[],
				dialog_transaction_list:false,
				loadMore:false,
				showPlaceHolder:false,
                pendingInvoices:[],
				clearValue:null,
				selectedDueDays:null,
				selectedDate:null,
				dialog_datepicker:false
			}
		},
		methods:{

			fn_InvoicePaymentReminder: function(item, type){
				let shareObj = {};
				shareObj.shareType = type=='sharewhatsapp' ? 'share' : 'ShareOther';

		  		let title = 'Payment Reminder';
		  		
				// shareObj.shareVia = this.displayData.primaryMobileNumber && type == 'sharewhatsapp' ? 'ShareOnWhatsApp' : 'Share';
				shareObj.type = 'text/plain';
				shareObj.primaryMobileNumber = item.primaryMobileNumber && type == 'sharewhatsapp' ? item.primaryMobileNumber : null;
				// shareObj.subject = title + " Details";
				shareObj.subject = title + " #" + item.baseTransactionNumber + " from " + this.$root.CurrentBusiness.BusinessName;
				shareObj.email = item.email ? [this.displayData.email] : null ;

				let party = item.partyName ? item.partyName + ',' : '';

        		// shareObj.textMessage = "Dear "+party+"\n\nBelow are your " + title + " details. Please find the attached pdf.\n\nTransaction Date: "+this.$moment(this.displayData.transactionDate).format('DD-MMM-YYYY')+"\nTotal Amount: ₹ "+this.$root.fixed2Decimal(this.displayData.roundedAmount)+"\n\nThank You,\n"+this.$root.CurrentBusiness.BusinessName;
        		shareObj.textMessage = this.$tShare('share.paymentReminder', {
        			party: party,
        			amount: this.$root.numberToLocale(this.roundUpto2Decimals(item.outStandingAmount)),
        			title: this.fn_transactionName(item),
        			number: item.baseTransactionNumber,
        			date: this.$moment(item.transactionDate).format('DD-MMM-YYYY')
        		})
				// shareObj.textMessage = "Dear "+this.displayData.partyName+",\n\nBelow are your invoice details. Please find the attached pdf of your invoice.\n\nInvoice Date: "+this.$moment(this.displayData.createdDate).format('DD-MMM-YYYY')+"\nTotal Amount: ₹ "+this.$root.fixed2Decimal(this.displayData.roundedAmount)+"\n\nThank You,\n"+this.$root.CurrentBusiness.BusinessName;
				// this.fn_getPrintData('InvoiceData', this.displayData.transactionId, 'pdf', shareObj);
				this.$root.fn_share(shareObj);
			},

			fn_openDatePicker: function () {
				// this.fn_openDialogWeb('web', 'OTP', 'ref_dialogDatePicker');
				this.dialog_datepicker = true;
			},

			fn_updateDate: function (value) {
				this.selectedDate = this.$moment(value).format('DD-MMM-YYYY');
				// Define two dates
				const date1 = new Date(value);
				const date2 = new Date();

				let isPositive = date1 > date2 ? true : false;

				// Calculate the difference in milliseconds
				const diffInMs = Math.abs(date2 - date1);

				// Convert milliseconds to days
				// let diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
				let diffInDays = null;
				if(isPositive){
					diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
				}
				else{
					diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
				}

				let dayValue = !isPositive ? -diffInDays : diffInDays;

				console.log(diffInDays); // Output: 23

				this.dialog_datepicker = false;

				this.fn_searchItem(dayValue, true);				
			},

			fn_openDueDays: function(){
				this.$refs['ref_dialogDueDays'].openDialogWeb();
			},

			fn_updateDueDate: function(dueDays){
				this.selectedDueDays = dueDays;
				this.fn_searchItem();
				this.$refs['ref_dialogDueDays'].closeDialogWeb();
			},

			fn_newInvoice: function(){
				localStorage.setItem("SetDataDrive", 1);
				this.$router.push({path:'/transactions/sales/saleinvoice/items/new', query:{tagId:this.guidWeb()}});
			},

			onScroll: function(event){
				var element = event.target;
			    if (element.documentElement.scrollHeight - element.documentElement.scrollTop - 150 <= element.documentElement.clientHeight)
			    {
			        console.log('scrolled');
			        if(this.listItemObject.items.length < this.listItemObject.totalCount){
			        	this.fn_loadItems();
			        }
			    }
			},

			fn_transactionName: function(item){
				for(let i=0; i<transactionForms.length; i++){
					if(transactionForms[i].id == item.transactionListId){
						return transactionForms[i].title;
					}
				}
			},

			fn_openFilterDialog: function(){
				this.transactionForms = JSON.parse(JSON.stringify(transactionForms));

				this.transactionForms = this.transactionForms.filter(item=>{
					return item.id == 10003 || item.id == 10004 || item.id == 20003 || item.id == 20004 || item.id == 20005
				})
				
				this.dialog_transaction_list = true;
			},

			fn_selectItems: function(listId){
				let isRemoved = false;

				let itemIndex = this.selectedTransactionListIds.findIndex(transactionListId=>{
					return transactionListId == listId;
				});

				if(itemIndex != -1){
					this.selectedTransactionListIds.splice(itemIndex, 1);
				}
				else{
					this.selectedTransactionListIds.push(listId)	
				}

				let obj = {};
				obj.selectedTransactionListIds = this.selectedTransactionListIds;
				localStorage.setItem('activity_invoices_filter', JSON.stringify(obj));

				this.fn_searchItem();
			},

			fn_clearAll: function(){
				this.selectedTransactionListIds = [];
				this.dialog_transaction_list = false;
				localStorage.removeItem('activity_invoices_filter');
				this.fn_searchItem();
			},

			// fn_filterTransaction: function(transactionListId){
			// 	if(transactionListId == 'sale'){
			// 		this.transactionListId = transactionTypes.salesInvoice.id;	
			// 	}
			// 	else if(transactionListId == 'receipt'){
			// 		this.transactionListId = transactionTypes.receipt.id;	
			// 	}
			// 	else{
			// 		this.transactionListId = transactionListId;
			// 	}
			// 	this.fn_searchItem();
			// },

			// fn_updateSearch: function(value){
			// 	this.searchValue = value;
			// },

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit'){
					this.$router.push('/transactions/sales/'+this.toolbarTitle.toLowerCase().replace(/ /g,'')+'/items/'+this.selectedItemId+'/edit');
				}
				else if(menuAction=='copy'){
					this.$router.push({path:"/transactions/sales/"+this.toolbarTitle.toLowerCase().replace(/ /g,'')+"/items/new", query:{tagId:this.guidWeb(), itemId:this.selectedItemId, copy:true}});
				}
				// else if(menuAction == 'filter'){
				// 	// here "menuId" == "transactionListId"
				// 	this.fn_filterTransaction(menuId);
				// }
			},

			fn_itemClick: function (item) {
				// let obj = {};
				// obj.itemId = null;
				// obj.lastScrollPos = window.pageYOffset;
				// obj.itemIndex = index + 1;
				// localStorage.setItem("transaction_items_state", JSON.stringify(obj));

				this.$root.fn_navigateToDisplayView(item.transactionListId, item.baseTransactionId);
				// this.$router.push('/transactions/sales/'+this.toolbarTitle.toLowerCase().replace(/ /g,'')+'/items/'+itemId);
			},

			// fn_getBottomMenu: function (elementId, itemId) {
			// 	itemId ? this.selectedItemId = itemId : '';

			// 	let bottomMenu;

			// 	if(elementId == bottomSheetMenu.toolBar.Id){
			// 		bottomMenu = {"BottomMenu": [menuItem.help]};
			// 	}
			// 	else if(elementId == bottomSheetMenu.masterListItems.Id){
			// 		bottomMenu = {"BottomMenu": [menuItem.edit]};
			// 	}
				
			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			// infiniteHandler($state) {
		 //    	let filterObject = {};
			// 	filterObject.limit = 10;
			// 	filterObject.startIndex = this.startIndex;
			// 	!this.searchValue ? this.searchValue = '' : '';
			// 	filterObject.search = this.searchValue.toLowerCase();
			// 	this.selectedTransactionListIds && this.selectedTransactionListIds.length ? filterObject.transactionListId = this.selectedTransactionListIds : '';

			// 	let self = this;
			// 	this.getItems("AllTransactionList", filterObject, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 				let responseJson = JSON.parse(response);
			// 				self.listItemObject.totalCount = responseJson.totalCount;
			// 				self.listItemObject.saleTotal = responseJson.saleTotal ? responseJson.saleTotal : 0;
			// 				self.listItemObject.receiptTotal = responseJson.receiptTotal ? responseJson.receiptTotal : 0;

			// 				for(let i in responseJson.items){
			// 					self.listItemObject.items.push(responseJson.items[i]);	
			// 				}
			// 				// self.listItemObject.items = self.listItemObject.items.concat(responseJson.items);
			// 				self.startIndex = self.listItemObject.items.length;

			// 				if(self.listItemObject.items.length < self.listItemObject.totalCount){
			// 					$state.loaded();
			// 				}
			// 				else{
			// 					$state.complete();
			// 				}

			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
		 //    },

		 fn_loadItems: function() {
				this.loadMore = true;
		    	let filterObject = {};
				filterObject.limit = 50;
				filterObject.startIndex = this.startIndex;
				!this.searchValue ? this.searchValue = '' : '';
				filterObject.search = this.searchValue.toLowerCase();

				if(localStorage.getItem('activity_invoices_filter')){
					let data = JSON.parse(localStorage.getItem('activity_invoices_filter'));
					this.selectedTransactionListIds = data.selectedTransactionListIds;
				}

				filterObject.formTransactionListId = [30001, 30002];

				if(this.selectedTransactionListIds && this.selectedTransactionListIds.length){
					filterObject.transactionListId = this.selectedTransactionListIds;
				}
				else{
					filterObject.transactionListId = [transactionTypes.salesInvoice.id, transactionTypes.salesReturn.id, transactionTypes.bwbRefPurchaseInvoice.id, transactionTypes.bwbRefSaleInvoice.id, transactionTypes.purchaseInvoice.id, transactionTypes.purchaseReturn.id, transactionTypes.expense.id, transactionTypes.bwbRefPurchaseInvoice.id, transactionTypes.bwbRefSaleInvoice.id];
				}

				if(this.selectedDueDays){
					filterObject.dueDays = this.selectedDueDays;
				}

				filterObject.endDate = this.$moment(new Date()).endOf('day');
				filterObject.endDate = this.$root.fn_getLocalDateFormat(filterObject.endDate);

				let pageState = null;
				if(localStorage.getItem("transaction_items_state")){
					pageState = JSON.parse(localStorage.getItem("transaction_items_state"));
					filterObject.limit = 50 - (pageState.itemIndex % 50) + pageState.itemIndex;
				}

				let self = this;
				this.getItems("ActivityInvoiceList", filterObject, 
					{
						onSuccess: function (response) {
							console.log(response);
							let responseJson = JSON.parse(response);
							self.listItemObject.totalCount = responseJson.totalCount;
							self.listItemObject.saleTotal = responseJson.saleTotal ? responseJson.saleTotal : 0;
							self.listItemObject.receiptTotal = responseJson.receiptTotal ? responseJson.receiptTotal : 0;

							for(let i in responseJson.items){
								let itemIndex = self.listItemObject.items.findIndex(item => item.transactionId==responseJson.items[i].transactionId);

								if(itemIndex==-1){
									responseJson.items[i].transactionId = responseJson.items[i].baseTransactionId;
									responseJson.items[i].mergeTransactionNumber = responseJson.items[i].baseTransactionNumber;
									self.listItemObject.items.push(responseJson.items[i]);	
								}
							}

							console.log(pageState);
							if(pageState && pageState.itemId){
								setTimeout(function(){
									let scrollOptions = {"duration":0, "offset":0, "easing":"linear"};
									self.$vuetify.goTo('#item_'+pageState.itemId, scrollOptions);
									localStorage.removeItem("transaction_items_state");
								},100);
							}

							if(pageState && !pageState.itemId){
								setTimeout(function(){
									let scrollOptions = {"duration":300, "offset":0, "easing":"linear"};
									self.$vuetify.goTo(pageState.lastScrollPos, scrollOptions);
									localStorage.removeItem("transaction_items_state");
								},100);
							}

							self.startIndex = self.listItemObject.items.length;
							self.loadMore = false;

							setTimeout(function(){
								self.showPlaceHolder = true;
							},300);
						},
						onError: function (error) {
							console.log(error);
							self.loadMore = false;
						}
					}
				)
		    },

			fn_searchItem: function (dueDays, date) {
				this.startIndex = 0;
				this.listItemObject.items = [];
				if(dueDays != undefined){
					this.selectedDueDays = dueDays;
				}

				if(!date){
					this.selectedDate = null;
				}

				if(isNaN(dueDays)){
                    this.selectedDueDays = null;
                }

				this.fn_loadItems();
			},

			// fn_loadItems: function () {

            //     let filterObject = {};
            //     filterObject.formTransactionListId = [30001, 30002];

			// 	if(this.selectedTransactionListIds && this.selectedTransactionListIds.length){
			// 		filterObject.transactionListId = this.selectedTransactionListIds;
			// 	}
			// 	else{
			// 		filterObject.transactionListId = [transactionTypes.salesInvoice.id, transactionTypes.salesReturn.id, transactionTypes.bwbRefPurchaseInvoice.id, transactionTypes.bwbRefSaleInvoice.id, transactionTypes.purchaseInvoice.id, transactionTypes.purchaseReturn.id, transactionTypes.expense.id, transactionTypes.bwbRefPurchaseInvoice.id, transactionTypes.bwbRefSaleInvoice.id];
			// 	}

            //     let self = this;
            //     this.getFilterData('ActivityInvoiceList', null, filterObject, 
            //         {
            //             onSuccess: function(response){
            //                 console.log(response);
            //                 self.pendingInvoices = JSON.parse(response);
            //             }, 
            //             onError: function(error){
            //                 console.log(error);
            //             }
            //         });
            //     },

				fn_markClear: function(value){
					this.clearValue = value;
					this.$forceUpdate();
					setTimeout(() => {
						this.hideBottomNavigation();
						this.$refs['ref_dialogMarkClear'].openDialogWeb();
					}, 300);
				},

		    // fn_searchItem: function () {
		    // 	// this.showPlaceHolder = false;
			// 	this.startIndex = 0;
			// 	this.listItemObject.items = [];
			// 	this.fn_loadPendingItems();
			// },
		},

		// computed:{
		// 	filteredItems: function () {
		// 		let searchText = this.searchValue.toLowerCase();

		// 		if(this.pendingInvoices && this.pendingInvoices.length){

		// 			return this.pendingInvoices.filter(item => {
		// 				let keyword = searchText.toLowerCase();

		// 				let transactionNumberString = ''

		// 				if(item.baseTransactionNumber){
		// 					transactionNumberString = item.baseTransactionNumber.toLowerCase();
		// 				}
		// 				else if(item.baseRefNumber){
		// 					transactionNumberString = item.baseRefNumber.toLowerCase();	
		// 				}

		// 				return transactionNumberString.match(keyword);
		// 			});
					
		// 		}
		// 		else{
		// 			return [];
		// 		}
		// 	}
		// }
	}
</script>


// WEBPACK FOOTER //
// src/components/activity/contents/invoices.vue